import type { MagicEdenPoolOfferRef } from "@anaconda/core/bid/types"
import type { Nft } from "@anaconda/core/nft/types"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaAcceptMagicEdenPoolBidMoleculeReatom } from "./solana-accept-magic-eden-pool-bid-molecule.reatom"

export function useSolanaAcceptMagicEdenPoolBid() {
  const { acceptMagicEdenPoolBidActionFactory } = useMolecule(
    SolanaAcceptMagicEdenPoolBidMoleculeReatom,
  )
  const acceptAction = useMemo(
    () => acceptMagicEdenPoolBidActionFactory(),
    [acceptMagicEdenPoolBidActionFactory],
  )

  const mutate = useCallback(
    (params: { nft: Nft; offer: MagicEdenPoolOfferRef }) => {
      void (async () => {
        try {
          await acceptAction(params).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [acceptAction],
  )

  return {
    mutate,
    isPending: !!acceptAction.pending(),
  }
}
